import { useEffect } from 'react';
import { DefaultInputPropTypes, InputList, useInputHelper, InputListLayoutProps } from 'framework/form';
import useAdditionalContactsHelper from './useAdditionalContactsHelper';
import { isEmpty, isEqual } from 'lodash';
import AdditionalContactInput from './AdditionalContactInput';
import { Box } from '@mui/material';

type AdditionalContactListInputProps = DefaultInputPropTypes<any> & {
  maxFields?: number;
  CustomInputListLayout?: ReactComponent<InputListLayoutProps> | null;
};

const AdditionalContactListInput = (props: AdditionalContactListInputProps) => {
  const { getValue, initializeValue } = useInputHelper(props);
  const { getPreparedAdditionalContacts } = useAdditionalContactsHelper();
  const value = getValue();

  useEffect(() => {
    if (isEmpty(value) || isEmpty(value[0])) {
      initializeValue([{}]);
      return;
    }
    const updatedContacts = getPreparedAdditionalContacts(value);

    if (!isEqual(updatedContacts, value)) {
      initializeValue(updatedContacts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ '& .form-group': { mt: 0 } }}>
      <InputList {...props} inputTemplate={AdditionalContactInput} addText="" />
    </Box>
  );
};

export default AdditionalContactListInput;
